import { SelMessage } from "@selector/shared/components";
import type { FC } from "react";
import { useNavigate } from "react-router";
import { Card, CardRowSimple, type GridCard } from "widgets";

import type { Dataset } from "@/graphql.ts";
import { FileTile } from "@/modules/files/components/FileTile.js";

export interface IDatasetsCardProps extends GridCard {
  title?: string;
  datasets: Dataset[];
}

const DatasetsCard: FC<IDatasetsCardProps> = (props) => {
  const navigate = useNavigate();

  if (props.datasets.length === 0) {
    return null;
  }

  const getDefaultInfo = (ds: Dataset): string | undefined => {
    if (ds.isGlobalDefault && ds.isGenomeDefault) {
      return "global default- and default dataset of this genome";
    } else if (ds.isGenomeDefault) {
      return "default dataset of this genome";
    } else if (ds.isGlobalDefault) {
      return "global default dataset";
    }
  };

  const content =
    props.datasets.length > 0 ? (
      <>
        {props.datasets.map((ds) => {
          const f = ds.fileMetadata;

          if (!f) return null;

          return (
            <FileTile
              file={f}
              onPress={() => navigate(`/visualizer/data/dataset/${ds.id}`)}
              tooltip={"Send to Analytical Data Viewer"}
              footNote={getDefaultInfo(ds)}
              key={`ds-card-elem-${ds.id}`}
            />
          );
        })}
      </>
    ) : (
      <SelMessage id={"noContent.datasets"} />
    );
  return (
    <Card
      shrinkable={props.datasets.length > 7}
      title={props.title ?? "Datasets"}
      tag={{ label: String(props.datasets.length) }}
      icon={"bar_chart"}
    >
      <CardRowSimple>{content}</CardRowSimple>
    </Card>
  );
};

export { DatasetsCard };
